export type Language = {
    locale: string;
    currencyId: string;
    name: string;
}

export const languages: Language[] = [
    { locale: 'en', currencyId: '6103c9912d76c68c2d4996b9', name: 'English' }, // English
    { locale: 'fr', currencyId: '6103c9812d76c68c2d4996b2', name: 'Français' }, // French
    { locale: 'ar', currencyId: '66fd62f085fe1b7df66a515f', name: 'العربية' }, // Arabic
    { locale: 'zh', currencyId: '66fd62e885fe1b7df66a4fd7', name: '中文' }, // Chinese
    { locale: 'nl', currencyId: '6103c9812d76c68c2d4996b2', name: 'Nederlands' }, // Dutch
    { locale: 'de', currencyId: '6103c9812d76c68c2d4996b2', name: 'Deutsch' }, // German
    { locale: 'hi', currencyId: '66fd62eb85fe1b7df66a5079', name: 'हिन्दी' }, // Hindi
    { locale: 'it', currencyId: '6103c9812d76c68c2d4996b2', name: 'Italiano' }, // Italian
    { locale: 'ja', currencyId: '66fd62eb85fe1b7df66a509c', name: '日本語' }, // Japanese
    { locale: 'ko', currencyId: '66fd62ec85fe1b7df66a50b0', name: '한국어' }, // Korean
    { locale: 'pl', currencyId: '66fd62f085fe1b7df66a5141', name: 'Polski' }, // Polish
    { locale: 'pt', currencyId: '6103c9812d76c68c2d4996b2', name: 'Português' }, // Portuguese
    { locale: 'ru', currencyId: '61b2249ae77d8c4d8265200d', name: 'Русский' }, // Russian
    { locale: 'es', currencyId: '6103c9812d76c68c2d4996b2', name: 'Español' }, // Spanish
    { locale: 'th', currencyId: '66fd62f185fe1b7df66a517d', name: 'ไทย' }, // Thai
    { locale: 'tr', currencyId: '66fd62f185fe1b7df66a518c', name: 'Türkçe' }, // Turkish
    { locale: 'vi', currencyId: '66fd62f385fe1b7df66a51b9', name: 'Tiếng Việt' } // Vietnamese
];
